enum RecipientTypes {
    User = 0,
    Teacher = 1,
    Student = 2,
    EmergencyTeacher = 3,
    ArchiveStudent = 4,
    StudentContact = 5,
    ArchiveTeacher = 6
}

export default RecipientTypes;